export default __webpack_public_path__ + "static/media/flag-memo.40451281.png";